import React from "react";

export default function Progress(props: {progress: number}) {

    return (
        <div className="w-full bg-gray-200 h-1">
            <div className="bg-red-600 h-1" style={{width: `${props.progress}%`}}></div>
        </div>
    );

}